const Validator = {
    /**
     *
     * @param str 手机号
     */
    isPhone(str) {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        return reg.test(str);
    },
    getPhoneValidator(isRequire: boolean) {
        let validPhone = (rule, value, callback) => {
            if (!value) {
                if (isRequire) {
                    callback(new Error('请输入手机号码'));
                } else {
                    callback();
                }
            } else if (!Validator.isPhone(value)) {
                callback(new Error('请输入正确的11位手机号码'));
            } else {
                callback();
            }
        };
        return validPhone;
    },
    /**
     *
     * @param str 金额   可保留两位小数的数字
     */
    isMoney(str) {
        const reg = /^[0-9]+(\.[0-9]{1,2})?$/;
        return reg.test(str);
    },
    getMoneyValidator(isRequire: boolean) {
        let validPhone = (rule, value, callback) => {
            if (!value) {
                if (isRequire) {
                    callback(new Error('请输入总金额'));
                } else {
                    callback();
                }
            } else if (!Validator.isMoney(value)) {
                callback(new Error('请输入正确的金额数字'));
            } else {
                callback();
            }
        };
        return validPhone;
    },
    getRuleNameValidator(isRequire: boolean) {
        let validRuleName = (rule, value, callback) => {
            if (Validator.strlen(value) < 4) {
                callback(new Error('规则名称长度为4~30'));
            } else {
                callback();
            }
        };
        return validRuleName;
    },
    /**获取字节长度 */
    strlen(str) {
        var len = 0;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            //单字节加1
            if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                len++;
            } else {
                len += 2;
            }
        }
        return len;
    }
};
export default {
    install: function (Vue, Option) {
        Object.defineProperty(Vue.prototype, '$valid', { value: Validator });
    }
};
export let vform = {
    repassword:''
}
let validatePass2 = (rule, value, callback) => {
    console.log('value',value,vform)
if(value === '' && vform.repassword == ''){
    callback();
}else if (value === '') {
    callback(new Error('请再次输入密码'));
} else if (value !== vform.repassword) {
    callback(new Error('两次输入密码不一致!'));
} else {
    callback();
}
};
let percentagevalidator = (rule, value, callback) =>{
    if(value == 0){
        callback(new Error('最小值不能为0'));
    }else if(value ==''){
        callback(new Error('最小值不能为空'));
    }else{
        callback();
    }
}
export var formRules = {
    // phone:{validator : Validator.getPhoneValidator(true),trigger:'change' }  /* 自定义校验 */
    /* input框 */
    trainingDuration: [
        {
            required: false,
            pattern: /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/,
            message: '精确到两位小数，勿超过100'
        }
    ],
    preMoney: [
        {
            required: true,
            pattern: /^\d{1,9}(\.\d{1,2})?$/,
            message: '最多输入9位和2位小数'
        }
    ],
    price: [
        { required: true,  message: '此项为必填项', trigger: 'blur' },
        {
            pattern: /^\d{1,10}(\.\d{1,2})?$/,
            message: '请输入正确金额',
            trigger: 'change'
        }
    ],
    rate: [
        { required: true,  message: '此项为必填项', trigger: 'blur' },
        {
            pattern: /^\d{1,9}(\.\d{1,2})?$/,
            message: '请输入费率',
            trigger: 'change'
        }
    ],
    priceNo: [
        {
            pattern: /^\d{1,9}(\.\d{1,2})?$/,
            message: '请输入正确金额'
        }
    ],
    thousandMoney: [
        {
            required: true,
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: '最高额度：9999.99'
        }
    ],
    alphabet: [{ required: true, pattern: /^[0-9a-zA-Z]*$/, message: '支持数字、字母', trigger: 'blur' }],
    blur: [{ required: true, pattern: /\S/, message: '此项为必填项', trigger: 'blur' }],
    name: [{ required: true, pattern: /\S/, message: '请输入姓名', trigger: 'change' }],
    salesmanName: [{ required: true, pattern: /\S/, message: '此项为必填项', trigger: 'change' }],
    realName: [{ required: true, pattern: /\S/, message: '请输入姓名', trigger: 'change' }],
    level2name: [{ required: true, pattern: /\S/, message: '请输入字典项', trigger: 'blur' }],
    Id: [{ required: true, pattern: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/, message: '请输入正确的证件号', trigger: 'blur' }],
    newName: [{ required: true, pattern: /^[\u4E00-\u9FA5A-Za-z0-9\（\）\/]+$/, message: '请输入中英文数字名称', trigger: 'change' }],
    departmentName: [{ required: true, pattern: /^[\u4E00-\u9FA5]+$/, message: '请输入中文名称', trigger: 'change' }],
    departmentNamess: [{ required: true, pattern: /\S/, message: '请输入名称', trigger: 'blur' }],
    departmentNames: [{ required: true, pattern: /^[\u4E00-\u9FA5A-Za-z\（\）\/]+$/, message: '请输入中文数字名称', trigger: 'change' }],
    userName: [
        {
            required: true,
            pattern: /\S/,
            message: '请输入用户名',
            trigger: 'change'
        }
    ],
    consignee: [{ required: true, pattern: /\S/, message: '此项为必填项', trigger: 'change' }],
    address:[{ required: true, pattern: /\S/, message: '此项为必填项', trigger: 'change' }],
    noEmpty:[
        {
            pattern: /\S/,
            message: '请输入正确的用户名或密码',
            trigger: 'change'
        }
    ],
    /* select框 */
    change: [{ required: true, message: '此项为必填项', trigger: 'change' }],
    salesCanalId:[{ required: true, message: '此项为必填项', trigger: 'change' }],
    productId:[{ required: true, message: '此项为必填项', trigger: 'change' }],
    /* 登录密码 */
    password: [
        { min: 6, required: true, message: '请输入6位以上密码', trigger: 'change' }
        // { max: 20, required: true, message: '密码最多输入20位字符', trigger: 'change' }
    ],
    oldPwd: [
        { min: 6, required: true, message: '请输入6位以上密码', trigger: 'blur' }
        // { max: 20, required: true, message: '密码最多输入20位字符', trigger: 'change' }
    ],
    newPwd: [
        { min: 6, required: true, message: '请输入6位以上密码', trigger: 'change' }
        // { max: 20, required: true, message: '密码最多输入20位字符', trigger: 'change' }
    ],
    // /**判断数组是否为空 */
    // checkPass: [
    //     { validator: noemptylist,type: 'array', trigger: 'change' }
    //   ],
    /* 登录密码 */
    passwordNorequired: [
        { min: 6, required: false, message: '请输入6位以上密码', trigger: 'change' }
        // { max: 20, required: true, message: '密码最多输入20位字符', trigger: 'change' }
    ],
    password1: [
        { min: 6, required: true, message: '请输入6位以上密码', trigger: 'change' },
        {
            required: true,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
            message: '请输入字母数字组合密码',
            trigger: 'change'
        }
    ],
    /**备注 */
    remarks: [
        {
            max: 50,
            required: false,
            message: '请输入50字以内备注',
            trigger: 'change'
        }
    ],
    /**50字符内 */
    alias50: [
        {
            max: 50,
            required: true,
            message: '请输入50字以内字符',
            trigger: 'change'
        }
    ],
    days:[
        {
            required: true,
            pattern:/^([1-9]\d+|[1-9])$/,
            message: '最少为一天',
            trigger: 'blur'
        },
        {
            required: true,
            pattern: /^\d{1,4}?$/,
            message: '最高：9999'
        }
    ],
    percentage:[
        {
            required: true,
            pattern:/^(100|[1-9]?\d(\.\d\d?\d?)?)$/,
            message: '请输入最大值为一百的百分数',
            trigger: 'blur'
        },
        { required: true,validator: percentagevalidator, trigger: 'blur',message: '请输入最大值为一百的百分数',}
    ],
    /**20字符内 */
    alias20: [
        {
            max: 20,
            required: true,
            message: '请输入20字以内字符',
            trigger: 'change'
        }
    ],
    /**项目组名称 */
    projectName: [
        {
            required: true,
            pattern: /^[\u4E00-\u9FA5\（\）\/]{1,20}$/,
            message: '请输入20字以内中文名称',
            trigger: 'change'
        }
    ],
    /* 日期 */
    date: [{ required: true, message: '请选择日期时间', trigger: 'change' }],
    salesDate:[{ required: true, message: '请选择日期时间', trigger: 'change' }],
    /* 手机号验证 */
    phone: [
        {
            required: true,
            pattern: /^1[123456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'change'
        }
    ],
    /* 手机号验证 */
    phoneCode: [
        {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'change'
        }
    ],
    /* 身份证验证 */
    cardCode: [
        {
            required: true,
            pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur'
        }
    ],
    /* 短信验证码校验 */
    messageCode: [
        {
            required: true,
            pattern: /^\d{6}$/,
            message: '请输入6位数字验证码',
            trigger: 'blur'
        }
    ],
    /* 密码校验 */
    pass: [
        {
            min: 6,
            required: false,
            message: '请输入6位以上密码',
            trigger: 'change'
        },
        {
            required: false,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
            message: '请输入字母数字组合密码',
            trigger: 'change'
        }
    ],
    checkPass: {},
    /* 0-1 保留两位小数 */
    percent: [
        {
            required: true,
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            message: '请输入0到1区间的数字'
        }
    ],
    intNum: [{ pattern: /^[0-9]*$/, message: '请输入正整数' }],
    timeCycle: [{ required: true, pattern: /^[0-9]*$/, message: '请输入正确的数字' }],
    number: [{ pattern: /^[0-9]+(.[0-9]{1,4})?$/, message: '请输入正确的数字' }],
    // 保留小数点后两位
    twoDecimalPoint: [{ required: true, pattern: /^[0-9]+(.[0-9]{1,2})?$/, message: '请输入正确的数字' }],
    numberRequired: [
        {
            required: true,
            pattern: /^[0-9]+(.[0-9]{1,4})?$/,
            message: '请输入正确的数字'
        }
    ],
    projectTotalRequired: [
        { pattern: /^[0-9]{1,6}?$/, message: '请输入正确的数字' },
        { required: true, message: '此项为必填项', trigger: 'blur' }
    ],
    email: [
        {
            required: true,
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入正确邮箱'
        }
    ],
    contactname: [
        { required: true, pattern: /\S/, message: '此项为必填项', trigger: 'blur' },
        {
            required: true,
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9_]{0,20}$/,
            message: '联系人最多输入20位字符',
            trigger: 'change'
        }
    ],
    adminpassword: [
        {
            required: true,
            pattern: /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,20}$/,
            message: '6-20位字符,数字/字母/符号（除空格）至少包括2种'
        }
    ],
    adminname: [
        {
            required: true,
            pattern: /^[a-zA-Z0-9_]{3,12}$/,
            message: '3-12位字符，字母/数字/下划线，区分大小写'
        }
    ],
    codeValue: [{ required: true, pattern: /^[0-9]{6}?$/, message: '验证码格式错误' }],
    diskSize: [
        {
            required: true,
            pattern: /^(?:[1-9]?\d|100)$/,
            message: '只能输入0-100%',
            trigger: 'change'
        }
    ],
    diskTotal: [{ required: true, pattern: /^[0-9]*$/, message: '只能输入0-9数字' }],
    validCode: [
        { required: true, message: '此项不能为空' },
        { min: 6, required: true, message: '请输入6位以上密码' },
        { required: true, pattern: /^[0-9]*$/, message: '只能输入0-9数字' }
    ],
    identityNo: [
        {
            required: true,
            pattern: /^[A-Z]{4}\d{11}$/,
            message: '请输入正确的标识',
            trigger: 'change'
        }
    ],
    /**验证密码是否重复 */
    repassword:[
        {required: true,  validator: validatePass2, trigger: 'blur' }
    ],
    // 成长验证
    chengzhangTime: [{ required: true, pattern: /\S/, message: '成长日期不可为空', trigger: 'change' }],
    chengzhangRemark: [{ required: true, pattern: /\S/, message: '成长内容不可为空', trigger: 'blur' }],
};

export var addSignForms = {
    businessNum: [
        { required: true, message: '请输入企业内部业务编号', trigger: 'blur' },
        {
            required: true,
            pattern: /^[A-Za-z0-9]+$/,
            message: '格式错误，请输入数字、英文字母',
            trigger: 'change'
        }
    ],
    tags: [
        // JSON格式校验
        {
            validator: (rule, value, cb) => {
                if (value) {
                    try {
                        var obj = JSON.parse(value);
                        if (typeof obj == 'object' && obj) {
                            for (var key in obj) {
                                if (typeof obj[key] == 'string' && obj[key] != '' && typeof key == 'string' && key != '') {
                                    cb();
                                    return true;
                                } else {
                                    cb(new Error('标签数据格式为tags:{"a":"a","b":"b"},请检查'));
                                    return false;
                                }
                            }
                        } else {
                            cb(new Error('标签数据格式为tags:{"a":"a","b":"b"},请检查'));
                            return false;
                        }
                    } catch (e) {
                        cb(new Error('标签数据格式为tags:{"a":"a","b":"b"},请检查'));
                        return false;
                    }
                } else {
                    cb();
                    return true;
                }
            },
            trigger: 'change'
        }
    ]
};
export var messageTemplate = {
    templagetitle: [{ required: true, message: '模板标题不能为空', trigger: 'blur' }],
    templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
    templateNo: [{ required: true, message: '模板编号不能为空', trigger: 'blur' }],
    templateContent: [{ required: true, message: '模板内容不能为空', trigger: 'blur' }],
    taskName: [{ required: true, message: '任务名称不能为空', trigger: 'blur' }],
    sendingFrequency: [{ required: true, message: '发送频次不能为空', trigger: 'blur' }],
    sendingTime: [{ pattern: /\S/, required: true, message: '发送时间不能为空', trigger: 'blur' }],
    sendingChannel: [{ required: true, message: '请选择发送渠道', trigger: 'change' }],
    sendobj: [{ required: true,pattern:/\S/, message: '请选择发送对象', trigger: 'change' }],
    templateNos: [{required: true, message: '模板名称不能为空', trigger: 'blur'  }],
    
};
export var edtilmessages = {
    templateName: [{ required: true, message: '模板标题不能为空', trigger: 'change' }],
    templateContent: [{ required: true, message: '模板内容不能为空', trigger: 'change' }],
};
var noemptylist = (rule, value, callback) =>{
    console.log('value',value.length)
    if(value.length === 0){
        callback(new Error('请选择'));
    }else{
        callback();
    }
}


// WEBPACK FOOTER //
// ./src/common/util/validator.ts